<app-open-select
  #select
  [multiple]="multiple" 
  [placeholder]="placeholder" 
  [disabled]="disabled" 
  (selectedChange)="onChange($event)" 
  [items]="items"
></app-open-select>